import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { SwiperOptions } from 'swiper';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
  cat: string = 'default';
  value = '';
  id: string;
  showCategories: boolean = true;

  constructor(private activatedRoute: ActivatedRoute, public router: Router,  public dialog: MatDialog) {}

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    if (!this.router.url.includes('table')) {
      //this.openDialog();
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(CovidDialogOverviewExampleDialog, {
      width: '350px',
      //data: {name: "Gestes barrières en cours d'integration."},
      panelClass: 'covid-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  public changeCategories(cat: string) {
    this.cat = cat;
  }
}


@Component({
  selector: 'covid-dialog-overview-example-dialog',
  templateUrl: 'covid-dialog.html'
})
export class CovidDialogOverviewExampleDialog {
  config: SwiperOptions = {
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 30
  };

  constructor(
    public dialogRef: MatDialogRef<CovidDialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
